<template lang="html">
	<entity-page id="page__city" v-bind:loading="progress">
		<template slot="header-right">
            <z-icon-button v-bind:icon="['fa', 'xmark']" danger-light  rounded v-on:click="back"></z-icon-button>
            <z-icon-button v-bind:icon="['fa', 'check']" success-light rounded v-on:click="save"></z-icon-button>
        </template>
		<z-input
			v-model="city.name" name="name" id="name" label="Название" 
			v-validate="'required'" v-bind:error="errors.first('name')" v-bind:required="true"
			data-vv-name="name" v-bind:data-vv-as="' '"
		></z-input>

		<z-input
			v-model="city.value" name="value" id="value" label="Полное наименование" 
			v-validate="'required'" v-bind:error="errors.first('value')" v-bind:required="true"
			data-vv-name="value" v-bind:data-vv-as="' '"
		></z-input>

		<z-input
			v-model="city.aoguid" name="aoguid" id="aoguid" label="ФИАС" data-vv-name="aoguid" v-bind:data-vv-as="' '"
			v-validate="'required'" v-bind:error="errors.first('aoguid')" v-bind:required="true"
		></z-input>
		<z-input
			v-model="city.parentguid" name="parentguid" id="parentguid" label="ФИАС родителя" data-vv-name="parentguid" v-bind:data-vv-as="' '"
			v-bind:error="errors.first('parentguid')"
		></z-input>
		<z-input
			v-model="city.okato" name="okato" id="okato" label="ОКАТО" data-vv-name="okato" v-bind:data-vv-as="' '"
			v-bind:error="errors.first('okato')"
		></z-input>
		<z-input
			v-model="city.regioncode" name="regioncode" id="regioncode" label="Код региона" data-vv-name="regioncode" v-bind:data-vv-as="' '"
			v-validate="'min:3'" v-bind:error="errors.first('regioncode')"
		></z-input>
		<z-input-autocomplete
			v-model="city.zone_id" name="zone" id="zone" display-property="name" property="id" return="id" label="Направление" v-bind:callback="getZones" 
			v-bind:default="city.zone && city.zone.name ? city.zone.name : ''"
		></z-input-autocomplete>
    </entity-page>
</template>
<script>
	import ZInput from '@/components/ZInput';
	import EntityPage  from '@/components/EntityPage.vue';
    import ZIconButton from '@/components/ZIconButton';
	import ZInputAutocomplete from '@/components/ZInputAutocomplete';
	export default {
		components: { ZInputAutocomplete, ZInput, ZIconButton, EntityPage },
		data() {
			return {
				city: {},
				cityDefault: {
					id:  		null,
					name: 		null,
					sort: 		null,
					zone_id: 	null,
					aoguid: 	null,
					disid: 		null,
					okato: 		null,
					parentguid: null,
					regioncode: null,
					value: 		null,
					sort: 		100
				}
			}
		},
		computed: {
			/**
             * Флаг загрузки текущего компонента
             */
			progress() {
				return this.progressObj['load-city-card'];
			},
			/**
             * Объект с флагами загрузки
             */
			progressObj() {
				return this.$store.state.progressObj;
			}
		},
		created() {
			this.init();
		},
		methods: {
			/**
             * Инициализация компонента
             */
			init() {
				this.$store.commit('setTitle', 'Города');
				this.$store.commit('openRightPanel');
				if (this.$route.params.cityid !== 'new') this.getCity();
				else this.city = Object.assign({}, this.cityDefault);
			},
			/**
			 * Получение города
			 */
			getCity() {
				this.$store.commit('showProgressBar', 'load-city-card');
				return this.$store.dispatch('cost/getCity', this.$route.params.cityid).then(r => {
					this.city = Object.assign({}, r);
					return this.city;
				}).finally(() => this.$store.commit('hideProgressBar', 'load-city-card'));
			},
			/**
			 * Сохранение
			 */
			save() {
				this.$validator.validateAll().then(valid => {
					if (!valid) return;
					if (this.$route.params.cityid != 'new') this.putCity();
                    else this.postCity();
				});
			},
			/**
			 * Добавление города
			 */
			postCity() {
				this.$store.commit('showProgressBar', 'load-city-card');
				this.$store.dispatch('cost/addCity', this.city).then(r => {
					this.$root.$emit('reload-table', 'cities');
					this.$router.replace({name: 'City', params: {cityid: r.id}});
				}).finally(() => this.$store.commit('hideProgressBar', 'load-city-card'));
			},
			/**
			 * Изменение города
			 */
			putCity() {
				this.$store.commit('showProgressBar', 'load-city-card');
				this.$store.dispatch('cost/updateCity', this.city).then(r => {
					if (!r) return;
					this.init();
					this.$root.$emit('reload-table', 'cities');
				}).finally(() => this.$store.commit('hideProgressBar', 'load-city-card'));
			},
			/**
			 * Получение направлений
			 */
			getZones(string) {
				if (string && string.length > 2) return this.$store.dispatch('cost/getZones', {
					page: 1,
					count: 20,
					filter: {model: [['name', '%', string]]}
				});
			},
			/**
             *Возвращает пользователя на предыдущую страницу
            * Обрабочик события click, на кнопке "Закрыть" 
            */
			back() {
                this.$router.push({name: 'Cities', query: this.$route.query});
            }
		},
		watch: {
			'$route.params.cityid'() {
				this.init();
			}
		}
	}
</script>


// WEBPACK FOOTER //
// City.vue?5213fd26